import { render, staticRenderFns } from "./TextBoxQuestion.vue?vue&type=template&id=7ba56200&"
import script from "./TextBoxQuestion.vue?vue&type=script&lang=ts&"
export * from "./TextBoxQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba56200')) {
      api.createRecord('7ba56200', component.options)
    } else {
      api.reload('7ba56200', component.options)
    }
    module.hot.accept("./TextBoxQuestion.vue?vue&type=template&id=7ba56200&", function () {
      api.rerender('7ba56200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/typesOfQuestion/TextBoxQuestion.vue"
export default component.exports